import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from "@vueuse/core";
import { Tooltip, TooltipContent, TooltipTrigger } from '../../primitives/tooltip';
import SidebarMenuButtonChild from "./SidebarMenuButtonChild.vue";
import { useSidebar } from "./utils";
export default /*@__PURE__*/ _defineComponent({
    ...{
        inheritAttrs: false,
    },
    __name: 'SidebarMenuButton',
    props: {
        variant: { type: null, required: false, default: "default" },
        size: { type: null, required: false, default: "default" },
        isActive: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false, default: "button" },
        tooltip: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { isMobile, state } = useSidebar();
        const delegatedProps = reactiveOmit(props, "tooltip");
        const __returned__ = { props, isMobile, state, delegatedProps, get Tooltip() { return Tooltip; }, get TooltipContent() { return TooltipContent; }, get TooltipTrigger() { return TooltipTrigger; }, SidebarMenuButtonChild };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
